"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var d3 = _interopRequireWildcard(require("d3"));

var _HorizontalTickAxis = _interopRequireDefault(require("./HorizontalTickAxis"));

var _HorizontalAxisTitle = _interopRequireDefault(require("./HorizontalAxisTitle"));

var _AxisLabel = _interopRequireDefault(require("./AxisLabel"));

var _Bar = _interopRequireDefault(require("./Bar"));

var _BarLabel = _interopRequireDefault(require("./BarLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Hover styling done in CSS, remaining styling done in-line for portability (i.e. download or print)
var LabelGroup = _styledComponents.default.g.withConfig({
  displayName: "StackedBarChart__LabelGroup",
  componentId: "sc-1ko9j6e-0"
})(["   &:hover{& text{user-select:none;font-weight:bold;opacity:1.0}", "}"], function (_ref) {
  var hoverFill = _ref.hoverFill;
  return hoverFill.map(function (color, i) {
    return "\n      & > g:nth-child(".concat(i + 1, ") rect {\n        fill: ").concat(color, ";\n      }\n    ");
  });
});

var LEFT_PADDING = 60;
var RIGHT_PADDING = 12;
var BOTTOM_PADDING = 42;
var DATA_Y_START_PADDING = 30;
var DATA_X_START_PADDING = 25;
var BAR_HEIGHT = 25;
var BAR_GAP = 12;

var StackedBarChart = /*#__PURE__*/function (_Component) {
  _inherits(StackedBarChart, _Component);

  var _super = _createSuper(StackedBarChart);

  function StackedBarChart() {
    _classCallCheck(this, StackedBarChart);

    return _super.apply(this, arguments);
  }

  _createClass(StackedBarChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          colors = _this$props.colors,
          theme = _this$props.theme,
          valuesTitle = _this$props.valuesTitle,
          unitTitle = _this$props.unitTitle;
      var labels = data.labels,
          values = data.values;
      var ids = data.values.map(function (v) {
        return v.id;
      });
      var labelIds = Object.keys(labels);
      colors = colors || theme.data;
      var yAxisHeight = labelIds.length * (BAR_HEIGHT + BAR_GAP) + 2 * DATA_Y_START_PADDING;
      var xAxisWidth = width - LEFT_PADDING - DATA_X_START_PADDING - RIGHT_PADDING;
      var height = yAxisHeight + BOTTOM_PADDING; // Pivot data (Needed to utilize d3 stack function)

      var input = labelIds.map(function () {
        return new Object();
      });
      values.forEach(function (item) {
        return labelIds.forEach(function (labelId, i) {
          return input[i][item.id] = item[labelId];
        });
      }); // Prepare stacks

      var stack = d3.stack().keys(ids);
      var stackSeries = stack(input); // Find maximum X-value

      var last = stackSeries[stackSeries.length - 1];
      var endValues = last.map(function (item) {
        return item[1];
      });
      var maxX = Math.round(d3.max(endValues)); // Vertical draw scale (id -> y-coordinate)

      var scaleY = d3.scalePoint().range([0, yAxisHeight]).padding(DATA_Y_START_PADDING).domain(labelIds); // Horizontal draw scale 1 (value -> x-coordinate)

      var scaleX = d3.scaleLinear().range([0, xAxisWidth]).domain([0, maxX]).nice(10); // Text label scale (id -> text label)

      var scaleLabel = d3.scaleOrdinal().range(Object.values(labels)).domain(labelIds); // Primary color scale (id -> color)

      var scaleColor1 = d3.scaleOrdinal().range(colors.primary).domain(labelIds); // Secondary color scale (id -> color)

      var scaleColor2 = d3.scaleOrdinal().range(colors.secondary).domain(labelIds); // Labels

      var yLabels = scaleY.domain().map(function (id) {
        return /*#__PURE__*/_react.default.createElement(_AxisLabel.default, {
          key: id,
          x: 0,
          y: scaleY(id),
          value: scaleLabel(id)
        });
      }); // Bars

      var bars = stackSeries.map(function (segments, i) {
        var item = values[i];
        return /*#__PURE__*/_react.default.createElement(LabelGroup, {
          key: segments.key,
          hoverFill: scaleColor2.range()
        }, segments.map(function (segment, i) {
          if (!item[labelIds[i]]) return /*#__PURE__*/_react.default.createElement("g", null); // If value is missing or zero, return empty group

          return /*#__PURE__*/_react.default.createElement("g", {
            key: i
          }, /*#__PURE__*/_react.default.createElement(_BarLabel.default, {
            isBelow: i % 2 > 0,
            x1: scaleX(segment[0]),
            x2: scaleX(segment[1]),
            y: scaleY(labelIds[i]),
            value: item.name
          }), /*#__PURE__*/_react.default.createElement(_Bar.default, {
            value: item[labelIds[i]],
            x1: scaleX(segment[0]),
            x2: scaleX(segment[1]),
            y: scaleY(labelIds[i]),
            fill: scaleColor1(labelIds[i]),
            stroke: "white",
            height: BAR_HEIGHT,
            formatText: function formatText(v) {
              return "".concat(v, "%");
            },
            hasCenteredText: true
          }));
        }));
      }); // Compose SVG element

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING, ", 0)")
      }, yLabels), /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING + DATA_X_START_PADDING, ", ").concat(yAxisHeight, ")")
      }, /*#__PURE__*/_react.default.createElement(_HorizontalTickAxis.default, {
        scale: scaleX,
        tickCount: 10
      }), /*#__PURE__*/_react.default.createElement(_HorizontalAxisTitle.default, {
        scale: scaleX,
        title: valuesTitle,
        subtitle: unitTitle
      })), /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING + DATA_X_START_PADDING, ", 0)")
      }, bars)));
    }
  }]);

  return StackedBarChart;
}(_react.Component);

StackedBarChart.propTypes = {
  valuesTitle: _propTypes.default.string,
  unitTitle: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  data: _propTypes.default.shape({
    ids: _propTypes.default.arrayOf(_propTypes.default.string),
    labels: _propTypes.default.arrayOf(_propTypes.default.string),
    values1: _propTypes.default.arrayOf(_propTypes.default.number),
    values2: _propTypes.default.arrayOf(_propTypes.default.number)
  }),
  colors: _propTypes.default.shape({
    primary: _propTypes.default.arrayOf(_propTypes.default.string),
    secondary: _propTypes.default.arrayOf(_propTypes.default.string)
  })
};
StackedBarChart.defaultProps = {
  isLoading: false,
  valuesTitle: '',
  unitTitle: ''
};

var _default = (0, _styledComponents.withTheme)(StackedBarChart);

exports.default = _default;
//# sourceMappingURL=StackedBarChart.js.map